import React from 'react'
import User from '../features/user/user'
const HomePage = () => {
  return (
      <div>
          <User/>
      </div>
  )
}

export default HomePage